import React from "react";
import moment from "moment";
import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function ReadinessDetails({ sections, readinessData, swmsNumber: displaySwmsNumber }) {
  const safeSectionData = sections.document_project_details && sections.document_project_details.data || {};
  const readinessSource = readinessData && readinessData.emergency_readiness
    ? readinessData.emergency_readiness
    : (readinessData && readinessData.document ? readinessData.document : readinessData);
  const readinessQuestions = readinessSource && readinessSource.rescue_readiness_questions
    ? readinessSource.rescue_readiness_questions
    : (readinessSource || {});
  const swmsNumber = displaySwmsNumber || safeSectionData.swms_number || "";
  const readinessNumber = swmsNumber ? `${swmsNumber}-RDY` : "";
  const shiftId = readinessQuestions.shift_id;
  const readinessDate = readinessQuestions.readiness_date
    ? moment.utc(readinessQuestions.readiness_date).format("DD/MM/YYYY")
    : "";
  const supervisorDetails = readinessQuestions.shift_answers
    && readinessQuestions.shift_answers.supervisor_submission
    ? readinessQuestions.shift_answers.supervisor_submission
    : {};

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.readinessSectionNum}`}>1</span>
        Rescue Readiness Details
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewSectionSubHead}>Record Identity</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Readiness Checklist Id</span>
                <span className={styles.PreviewValue}>{readinessNumber || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Shift ID</span>
                <span className={styles.PreviewValue}>{shiftId || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Readiness Date</span>
                <span className={styles.PreviewValue}>{readinessDate || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Status</span>
                <span className={styles.PreviewValue}>{String(readinessQuestions.status || "").toLowerCase() === "approved" ? "Approved" : "Pending"}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={styles.PreviewSectionSubHead}>Linked Documents &amp; Work Context</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Linked SWMS</span>
                <span className={styles.PreviewValue}>{safeSectionData.swms_number || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Emergency Plan</span>
                <span className={styles.PreviewValue}>{swmsNumber ? `${swmsNumber}-ERP` : <span>&mdash;</span>}</span>
              </td>
              <td colSpan={2}>
                <span className={styles.PreviewLabel}>Applicable Procedures</span>
                <span className={styles.PreviewValue}>{swmsNumber ? `${swmsNumber}-PRO` : <span>&mdash;</span>}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={styles.PreviewSectionSubHead}>Shift Context</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Site Name</span>
                <span className={styles.PreviewValue}>{safeSectionData.site_name || <span>&mdash;</span>}</span>
              </td>
              <td colSpan={2}>
                <span className={styles.PreviewLabel}>Site Address</span>
                <span className={styles.PreviewValue}>{safeSectionData.site_address || <span>&mdash;</span>}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Supervisor</span>
                <span className={styles.PreviewValue}>{supervisorDetails.staff_name || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Position</span>
                <span className={styles.PreviewValue}>{supervisorDetails.job_title || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Phone</span>
                <span className={styles.PreviewValue}>{supervisorDetails.phone_number || <span>&mdash;</span>}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
